import CountDown from '@/components/ielts/speaking/CountDown';
import { checkpointInfoAtom, isFullScreenAtom } from '@/store/ieltsSpeaking';
import { useSetAtom, useAtomValue } from 'jotai';
import useTranslation from 'next-translate/useTranslation';
import Image from 'next/image';
import { useCallback, useMemo } from 'react';
import btnBack from '../images/btn-back.png';
import iconZoom from '../images/icon-zoom.png';
import iconZoomOut from '../images/icon-zoom-out.png';

function SpeakingHeaderSpeaking({
  onPressLeft,
  timeCountDown,
  onCountDownTimeout,
  title,
}: {
  onPressLeft: () => void;
  onCountDownTimeout?: () => void;
  timeCountDown?: number | null;
  title?: string;
}) {
  const setIsFullScreen = useSetAtom(isFullScreenAtom);
  const isFullScreen = useAtomValue(isFullScreenAtom);
  const dataCheckPoint = useAtomValue(checkpointInfoAtom);
  const { lang } = useTranslation('common');

  const toggleFullScreen = useCallback(() => {
    if (!document?.fullscreenElement) {
      document?.documentElement.requestFullscreen().finally(() => {
        setIsFullScreen(true);
      });
    } else if (document?.exitFullscreen) {
      document?.exitFullscreen().finally(() => {
        setIsFullScreen(false);
      });
    }
  }, [setIsFullScreen]);

  const renderNameCheckPoint = useMemo(() => {
    if (lang === 'vi' && dataCheckPoint?.name) {
      return dataCheckPoint?.name;
    }
    return dataCheckPoint?.nameEn || dataCheckPoint?.name || '';
  }, [dataCheckPoint?.name, dataCheckPoint?.nameEn, lang]);

  return (
    <div
      className="w-full bg-white h-[95px] flex flex-row justify-between rounded-t-[7px] relative z-10 cursor-pointer"
      style={{
        boxShadow: '0px 14px 14px 0px rgba(0, 0, 0, 0.05)',
      }}
    >
      <div
        aria-hidden
        className="flex flex-row items-center gap-[20px] w-[20%]"
        onClick={onPressLeft}
      >
        <Image alt="flyer back" src={btnBack} className="w-[87px] h-[80px]" />
        <div className="hidden md:flex flex-col">
          <span className="text-[25px]  text-[#1B64B0]">{title || 'IELTS'}</span>
          <span className="text-[14px]  text-[#1B64B0] whitespace-nowrap">
            {renderNameCheckPoint}
          </span>
        </div>
      </div>
      {timeCountDown && onCountDownTimeout && (
        <CountDown target={timeCountDown} onTimeout={onCountDownTimeout} />
      )}
      <div
        onClick={toggleFullScreen}
        aria-hidden
        className="flex flex-col items-end justify-center mr-[39px] cursor-pointer w-[20%]"
      >
        <Image
          alt="flyer"
          src={isFullScreen ? iconZoomOut : iconZoom}
          className="w-[40px] h-[40px]"
        />
      </div>
    </div>
  );
}

export default SpeakingHeaderSpeaking;
